module.exports = __webpack_public_path__ + "static/media/last-operations-icon.678fdd58.png";